import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import { IconMemo, IconProps } from "@insite/mobius/Icon";
import File from "@insite/mobius/Icons/File";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { css } from "styled-components";

/* Valtech Custom Code */
import translate from "@insite/client-framework/Translate";
import getColor from "@insite/mobius/utilities/getColor";
import Download from "@store/Components/Icons/Download";
import { TYPOGRAPHY } from "@store/theme/design";
import { actionLinkStyles } from "@store/theme/mixins";
import { productResourcesProps } from "@store/theme/props/productResources";
/* Valtech Custom Code */

type OwnProps = WidgetProps & HasProduct;

export interface ProductDetailsDocumentsStyles {
    wrapper?: InjectableCss;
    container?: GridContainerProps;
    documentGridItem?: GridItemProps;
    documentLink?: LinkPresentationProps;
    documentIcon?: IconProps;
    documentNameText?: TypographyPresentationProps;
    // Valtech Custom Code
    list?: InjectableCss;
    listItem?: InjectableCss;
    documentTypeText?: TypographyPresentationProps;
}

export const documentsStyles: ProductDetailsDocumentsStyles = {
    list: productResourcesProps.list,
    listItem: productResourcesProps.listItem,
    documentLink: productResourcesProps.resourceLink,
    documentTypeText: {
        css: css`
            font-style: italic;
        `,
    },
};

const styles = documentsStyles;

const ProductDetailsDocuments: React.FC<OwnProps> = ({ product: { documents } }) => {
    if (!documents || documents.length === 0) {
        return null;
    }

    /* Valtech Custom Code */
    return (
        <Typography as="ul" {...styles.list}>
            {documents.map(document => {
                const hasDuplicateType = documents.some(
                    x => x !== document && x.documentType === document.documentType,
                );

                return (
                    <Typography key={document.id.toString()} as="li" {...styles.listItem}>
                        <Link
                            href={document.filePath}
                            target="_blank"
                            {...styles.documentLink}
                            data-test-selector={`productDetails_${document.id}`}
                        >
                            <Typography {...styles.documentNameText}>
                                {translate(`DocumentType_${document.documentType}`)}
                                {hasDuplicateType ? (
                                    <Typography {...styles.documentTypeText}>
                                        {` (${document.description || document.name})`}
                                    </Typography>
                                ) : null}
                            </Typography>
                        </Link>
                    </Typography>
                );
            })}
        </Typography>
    );
    /* Valtech Custom Code */
};

const widgetModule: WidgetModule = {
    component: withProduct(ProductDetailsDocuments),
    definition: {
        displayName: "Documents",
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
    },
};

export default widgetModule;
